import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * GameCardSkeleton - Loading skeleton for GameCard
 * Matches the structure of GameCard with pulse animation
 */
export const GameCardSkeleton: React.FC = () => {
  return (
    <div
      className="bg-[#333333] rounded-xl p-4 border border-border/10"
      data-test-id="game-card-skeleton"
    >
      {/* Row 1: Top Row */}
      <div className="flex items-center justify-between mb-4">
        {/* Left: Icon + Title */}
        <div className="flex items-center gap-2">
          <Skeleton className="w-8 h-8 rounded-md" />
          <Skeleton className="w-32 h-5" />
        </div>

        {/* Right: Button placeholder */}
        <Skeleton className="w-24 h-10 rounded-md" />
      </div>

      {/* Horizontal Rule */}
      <div className="border-t-2 border-border/20 mb-4"></div>

      {/* Row 2: Bottom Row - Three Columns */}
      <div className="grid grid-cols-3 gap-4">
        {/* Column 1: Start */}
        <div className="flex flex-col gap-2">
          <Skeleton className="w-12 h-3" />
          <Skeleton className="w-16 h-4" />
        </div>

        {/* Column 2: Picks */}
        <div className="flex flex-col gap-2">
          <Skeleton className="w-12 h-3" />
          <Skeleton className="w-8 h-4" />
        </div>

        {/* Column 3: Prize */}
        <div className="flex flex-col gap-2 items-end">
          <Skeleton className="w-16 h-3" />
          <Skeleton className="w-20 h-4" />
        </div>
      </div>
    </div>
  );
};

export default GameCardSkeleton;
